import { render, staticRenderFns } from "./ApprovedSwitch.vue?vue&type=template&id=733ecedc&scoped=true&lang=pug"
import script from "./ApprovedSwitch.vue?vue&type=script&lang=ts"
export * from "./ApprovedSwitch.vue?vue&type=script&lang=ts"
import style0 from "./ApprovedSwitch.vue?vue&type=style&index=0&id=733ecedc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733ecedc",
  null
  
)

export default component.exports